import { render } from "./Hoststatus.vue?vue&type=template&id=0981d51a"
import script from "./Hoststatus.vue?vue&type=script&lang=js"
export * from "./Hoststatus.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__